import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {autocomplete} from '../../utils/autocomplete';
import ValidationMessage from './ValidationMessage';
import Group from './Group';

const NAME2ICON = {
  email: 'user',
  username: 'user',
  password: 'password',
  password_confirm: 'password',
  'given-name': 'user',
  'family-name': 'user',
  bday: 'date',
  'country-name': 'flag'
};

const RenderInput = ({
  showPassword,
  input,
  meta,
  icon,
  rightIcon,
  type,
  required,
  focused,
  showPasswordButton,
  ...field
}) => (
  <div className="input-container">
    {icon.length > 0 && <div className={`input-icon icon-${icon}`} />}

    {showPasswordButton &&
      icon === 'password' && (
        <div className="show-password-container">
          <div
            className={`show-password ${
              type !== 'password' ? 'password-visible' : 'password-hidden'
            }`}
            onClick={showPassword}
          />
        </div>
      )}

    {rightIcon && (
      <div className={classNames('input-icon', 'input-icon--right')}>
        <div
          className={classNames(`icon-${rightIcon}`, {[`icon-${rightIcon}--active`]: focused})}
        />
      </div>
    )}

    <input
      {...input}
      {...field}
      autoComplete={autocomplete(input.name || field.name)}
      type={type}
      name={input.name}
      className={classNames('form-input', {
        'right-iconed': showPasswordButton,
        'has-error': meta.touched && meta.error
      })}
    />

    {meta.touched && meta.error && <ValidationMessage>{meta.error}</ValidationMessage>}
  </div>
);

class TextInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: props.type,
      focused: false
    };

    this.showPassword = this.showPassword.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  showPassword() {
    this.setState({
      type: this.state.type === 'text' ? 'password' : 'text'
    });
  }

  handleFocus(e) {
    this.setState({focused: true});
    if (this.props.input.onFocus) {
      this.props.input.onFocus(e);
    }
  }

  handleBlur(e) {
    this.setState({focused: false});
    if (this.props.input.onBlur) {
      this.props.input.onBlur(e);
    }
  }

  render() {
    return (
      <Group>
        <RenderInput
          {...this.props}
          {...this.state}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          focused={this.state.focused}
          placeholder={this.props.label}
          icon={NAME2ICON[this.props.input.name] || this.props.icon || ''}
          showPassword={this.showPassword}
        />
      </Group>
    );
  }
}

TextInput.defaultProps = {
  type: 'text',
  icon: '',
  showPasswordButton: false
};

TextInput.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'password']),
  input: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  label: PropTypes.string,
  icon: PropTypes.string,
  rightIcon: PropTypes.string,
  disabled: PropTypes.bool,
  showPasswordButton: PropTypes.bool
};

export default TextInput;



// WEBPACK FOOTER //
// ./components/Form/TextInput.jsx